import React from "react";
import SREContent from "../function-components/learningCourses/SREContent";

function SRE() {
  return (
    <>
      <SREContent />
    </>
  );
}

export default SRE;
